<section class="bc-page">
  <div class="bc-container">
    @if (isLoading()) {
      <div class="animate-pulse" aria-busy="true" aria-label="Cargando confirmación">
        <div class="bc-skel h-10 w-4/5"></div>
        <div class="bc-skel mt-3 h-5 w-3/5"></div>
        <div class="bc-skel mt-8 h-96 w-full"></div>
      </div>
    } @else if (bookingData(); as data) {
      <header class="bc-head">
        <h1 class="bc-title">
          @if (firstName()) {
            Listo, {{ firstName() }}. Tu cita quedó agendada.
          } @else {
            Tu cita quedó agendada.
          }
        </h1>
        <p class="bc-subtitle">Te esperamos en {{ data.businessName }}. Guárdala en tu calendario para no olvidarla.</p>
      </header>

      <!-- The completed appointment ticket -->
      <article class="ticket" aria-label="Detalle de tu cita">
        <div class="ticket-head">
          @if (data.logoUrl) {
            <img [src]="data.logoUrl" alt="" class="ticket-logo" />
          }
          <div class="min-w-0">
            <p class="ticket-business">{{ data.businessName }}</p>
            @if (referenceCode()) {
              <p class="ticket-ref">Reserva {{ referenceCode() }}</p>
            }
          </div>
        </div>

        <div class="ticket-body">
          <dl class="ticket-rows">
            <div class="ticket-row">
              <dt>Servicio</dt>
              <dd>{{ data.serviceName }}</dd>
            </div>
            @if (data.professionalName) {
              <div class="ticket-row">
                <dt>Te atiende</dt>
                <dd>{{ data.professionalName }}</dd>
              </div>
            }
            <div class="ticket-row">
              <dt>Día</dt>
              <dd class="ticket-strong">{{ dayLabel() }}</dd>
            </div>
            <div class="ticket-row">
              <dt>Hora</dt>
              <dd class="ticket-strong">{{ timeRange() }}</dd>
            </div>
            @if (data.businessAddress) {
              <div class="ticket-row">
                <dt>Dirección</dt>
                <dd>
                  {{ data.businessAddress }}
                  <a [href]="getGoogleMapsUrl()" target="_blank" rel="noopener noreferrer" class="ticket-link">
                    Cómo llegar
                  </a>
                </dd>
              </div>
            }
          </dl>
        </div>

        <div class="ticket-perforation" aria-hidden="true"></div>

        <div class="ticket-stub">
          <p>A nombre de <strong>{{ data.clientName }}</strong></p>
          <p class="bc-stamp" aria-hidden="true">Confirmada</p>
        </div>
      </article>

      <div class="bc-actions">
        <a [href]="getGoogleCalendarUrl()" target="_blank" rel="noopener noreferrer" class="bc-btn bc-btn-primary">
          <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          Agregar a Google Calendar
        </a>

        @if (whatsAppUrl(); as waUrl) {
          <a [href]="waUrl" target="_blank" rel="noopener noreferrer" class="bc-btn bc-btn-secondary">
            <svg class="size-5 text-[#1faa53]" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
            Cambiar o cancelar por WhatsApp
          </a>
        }

        <button type="button" (click)="goToHome()" class="bc-back">
          Volver a {{ data.businessName }}
        </button>
      </div>
    } @else {
      <div class="bc-empty">
        <h1 class="bc-title">No encontramos esta reserva</h1>
        <p class="bc-subtitle">
          El enlace está incompleto o ya expiró. Si acabas de reservar, el negocio igual tiene tu cita registrada.
        </p>
        @if (slug()) {
          <button type="button" (click)="goToHome()" class="bc-btn bc-btn-primary mt-6">Ir a la página del negocio</button>
        }
      </div>
    }
  </div>

  <footer class="bc-footer">
    <a href="https://citalinkpro.com" target="_blank" rel="noopener noreferrer" class="bc-footer-link">
      Reservas con <strong>CitaLink Pro</strong>
    </a>
  </footer>
</section>
